<template>
  <div class="page-wrapper reg-link-wrap">
    <breadcrumb :items="breadcrumbItems" />
    <div class="page-title emp-grp-title">
      <div class="grp-title">
        <h1 class="mb-3">Export Logs</h1>
      </div>
    </div>
    <div class="bg-white">
      <div class="d-flex flex-wrap search-options gap-3 mb-3">
        <div class=""></div>
        <div class=""></div>
      </div>
      <div class="clientsData-wrap">
        <div class="top-pagination"></div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Path</th>
                <th>Started At</th>
                <th>Completed At</th>
                <th>Generated By</th>
                <th>Status</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="exportLogs.length === 0">
                <td colspan="7" class="text-center">No Export logs found</td>
              </tr>
              <!-- Example Row with Modal Trigger -->
              <tr v-for="log in exportLogs" :key="log.id">
                <td>{{ log.file_name }}</td>
                <td>
                  {{ log.file_path }}
                </td>
                <td>
                  {{ log.started_at }}
                </td>
                <td>{{ log.completed_at ?? "Pending" }}</td>
                <td>{{ log.exported_by }}</td>
                <td>{{ log.status }}</td>

                <td class="actions">
                  <div class="d-flex gap-2">
                    <div class="mr-2">
                      <b-button
                        v-if="log.status === 'completed' && log.download_url"
                        variant="link"
                        class="p-0 text-decoration-none d-flex align-items-center gap-1"
                        @click="downloadFile(log.download_url)"
                      >
                        <i class="fas fa-download"></i> Download
                      </b-button>
                      <div v-else>NA</div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../components/ui/Breadcrumb.vue";
import axios from "axios";
export default {
  name: "ExportLogs",
  components: {},
  Breadcrumb,
  data() {
    return {
      breadcrumbItemsMember: [
        { title: "Members", path: {name:"ViewMembers"} },
        { title: "View Exports", path:{name:"ViewExportLog", params:"member"}, active: true },
      ],
      breadcrumbItemsRep: [
        { title: "Downline Rep", path: {name:"DownlineRepList"} },
        { title: "View Exports", path:{name:"ViewExportLog", params:"member"}, active: true },
      ],
      exportLogs: [],
      type: null,
    };
  },
computed: {
  breadcrumbItems() {
    return this.type === 'downline-reps'
      ? this.breadcrumbItemsRep
      : this.breadcrumbItemsMember;
  }
},
  watch: {
    "$route.params.type": {
      handler(newVal) {
        this.type = newVal;
        this.getExportLogs();
      },
      immediate: true,
    },
  },
  methods: {
    downloadFile(url) {
  const fileName = url.split('/').pop();
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},
    async getExportLogs() {
      let url = `v2/export/get-member-report-log`;
      let loader = this.$loading.show();

      try {
        const response = await axios.get(url, {
          params: {
            type: this.type ?? "member",
          },
        });
        this.exportLogs = response.data.data;
      } catch (err) {
        this.$notify(
          err.response?.data?.message || "Failed to load logs",
          "error"
        );
      } finally {
        loader.hide();
      }
    },
  },

  mounted() {
    this.getExportLogs();
  },
};
</script>

<style>
/* Your existing styles */
.bg-white {
  background: #fff;
  padding: 1.5rem;
  border-radius: 6px;
}
.clientsData-wrap table tr th {
  background: #fafbfd !important;
  padding: 1rem;
  border: 1px solid #d7e1ea;
  border-bottom: 0;
}
.clientsData-wrap .table tbody tr {
  line-height: 26px;
}
.clientsData-wrap .table strong,
.clientsData-wrap .table thead th {
  color: #254050;
  font-weight: bold;
}
.clientsData-wrap .table tbody tr td {
  padding: 1rem;
  border: 1px solid #d7e1ea;
}
.advance-btn {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
  border: solid 1px #ced4da;
  border-radius: 6px;
  background-color: white;
  padding: 0.75rem;
}
.status {
  color: #fff;
  border-radius: 4px;
  padding: 0.2rem 0.8rem;
  font-size: 12px;
}
.delivered {
  background: rgb(2, 102, 2);
}
.sent {
  background: rgb(0, 102, 128);
}
.failed {
  background: red;
}
.pending {
  background: gray;
}
.bounced {
  background: orange;
}
.opened {
  background: rgb(173, 150, 1);
}
.quick-filter-wrap {
  max-height: 50px;
}
.quick-filter-wrap .label-dropdown {
  border: none;
  border-radius: 0;
}
.quick-filter-wrap .label-dropdown button {
  border: none;
  border-radius: 6px 0 0 6px;
  background: #f3f3f3;
  color: #254050;
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: 600;
}
.label-dropdown button:hover,
.label-dropdown button:active {
  border: none !important;
}
.quick-filter-wrap .dropdown-menu {
  padding: 0;
}
.quick-filter-wrap .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  padding: 0.5rem 0.8rem;
}
.quick-filter-wrap .dropdown-menu li:first-child {
  border-bottom: solid 1px #ced4da;
}
.quick-filter-wrap .dropdown-menu .selected-option a {
  color: #03c6ec;
  font-weight: 400;
}
.quick-filter-wrap .dropdown-input {
  border: none;
  border-radius: 0 6px 6px 0;
  background-color: #fafbfd;
  font-size: 14px;
  padding: 0.75rem 1rem;

  height: 100%;
}
.quick-filter-wrap .dropdown-input:focus {
  border: none;
}
.reg-link-wrap
  .clientsData-wrap
  > .table-responsive
  > .table
  > tbody
  td:nth-child(5) {
  width: auto;
  color: #03c6ec;
}
.btn-link {
  color: #03c6ec !important;
}
.btn-link:active,
.btn-link:focus {
  box-shadow: none !important;
}
.reg-link-wrap label {
  color: #254050;
  font-size: 14px;
  font-weight: 600;
}
.clear-filter {
  background: #eb2121;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
}
</style>
